import React from 'react'
import ReactDOM from 'react-dom'
import { fabric } from 'fabric'
import { StaticMathField } from 'react-mathquill'
import { createContainer } from '../helpers'

export const Formula = fabric.util.createClass(fabric.Rect, {
  type: 'Formula',
  initialize: function (options = {}) {
    this.type = 'Formula'
    this.data = options.data
    this.id = this.id || `formula-${Date.now()}`
    this.container = createContainer({ id: this.id })

    this.callSuper('initialize', {
      left: 100,
      top: 100,
      fill: 'rgba(0, 0, 0, 0)',
      ...options
    })

    this.updateElementDimensions()
    this.on('removed', function () {
      document.querySelector('.canvas-container').removeChild(this.container)
    })
    this.on('moving', function () {
      this.positionElement()
    })
    this.on('modified', function (modified) {
      if (modified.data) {
        this.renderElement(modified.data)
        this.updateElementDimensions()
      }
    })
    this.on('scaling', function () {
      this.renderElement()
    })
  },
  toObject: function () {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      type: 'Formula',
      data: this.get('data')
    })
  },
  _render: function (ctx) {
    this.callSuper('_render', ctx)

    this.renderElement()
  },
  updateElementDimensions: function () {
    const timeoutID = setTimeout(() => {
      const formulaNode = document.querySelector(`[data-id="${this.id}"]`)
      const { width, height } = formulaNode.getBoundingClientRect()

      this.set({ width, height })
      this.canvas.renderAll()
      clearTimeout(timeoutID)
    }, 0)
  },
  renderElement: function (data) {
    ReactDOM.render(
      <StaticMathField
        data-id={this.id}
        style={{
          color: 'white',
          transform: `scale(${
            this.scaleX * this.canvas.viewportTransform[0]
          }, ${this.scaleY * this.canvas.viewportTransform[3]})`,
          transformOrigin: 'left top'
        }}
      >
        {data || this.data}
      </StaticMathField>,
      this.container
    )
    this.positionElement()
  },
  positionElement: function () {
    const [canvasScaleX, _, __, canvasScaleY, left, top] = // eslint-disable-line
      this.canvas.viewportTransform
    const graph = this.container

    graph.style.left = this.left * canvasScaleX + left + 'px'
    graph.style.top = this.top * canvasScaleY + top + 'px'

    graph.style.width = this.get('width') + 'px'
    graph.style.height = this.get('height') + 'px'

    let transform = ''

    graph.style.width = this.get('width') * this.scaleX * canvasScaleX + 'px'
    graph.style.height = this.get('height') * this.scaleY * canvasScaleY + 'px'

    if (this.angle) transform += `rotate(${Math.round(this.angle)}deg) `

    if (transform) {
      graph.style['transform-origin'] = '0 0'
      graph.style.transform = transform
    }
  }
})
